import { ListGroup } from "reactstrap";
import { DraggableItem } from "./DragAndDropsComponent";
import atributesLogo from '../../Assets/atributesLogo.svg';




type Props = {
  selectedWallet: string;
  startDate: Date | null;
  endDate: Date | null;
  startDateConsulta: Date | null;
  endDateConsulta: Date | null;
  availableAttributes: any[];
};

export type AttributeType = 'boolean' | 'number' | 'date' | 'birthdate' | 'range' | 'fase' | 'string';
export interface Attribute {
  id: string;
  name: string;
  type: AttributeType | Attribute[];
  required?: boolean;
}

export const ValoresHistoricos: Attribute[] = [
  { id: '20', name: 'Autorizado Qi', type: 'boolean' },
  { id: '21', name: 'Autorizado Facta', type: 'boolean' },
  { id: '22', name: 'Autorizado Uy3', type: 'boolean' },
  { id: '23', name: 'Autorizado Bmp', type: 'boolean' },
  { id: '24', name: 'Data Cadastro', type: 'range', required: true },
  { id: '25', name: 'Fase', type: 'fase', required: true },
  { id: '26', name: 'Data Consulta', type: 'range', required: true },
];


const carteiraTrue: Attribute[] = [
  { id: '1', name: 'Liberado consulta', type: 'boolean' },
  { id: '2', name: 'Possui saldo', type: 'boolean' },
  { id: '3', name: 'Valor saldo', type: 'number' },
  { id: '4', name: 'Proposta cadastrada', type: 'boolean' },
  { id: '5', name: 'Reposição saldo', type: 'boolean' },
  { id: '6', name: 'Saque concorrente', type: 'boolean' },
  { id: '7', name: 'Data última compra', type: 'date' },
  { id: '8', name: 'Quantidade compras' as 'qtd_compras', type: 'number' },
  { id: '9', name: 'Intervalo entre compras', type: 'number' },
  { id: '10', name: 'Mes aniversário', type: 'birthdate' },
  { id: '11', name: 'Black list', type: 'boolean' },
  { id: '12', name: 'Projeção liberação saldo', type: 'date' },
  { id: '13', name: 'Última consulta', type: 'date' },
  { id: '14', name: 'Cadastro proposta', type: 'date' },
  { id: '15', name: 'Autorizado Qi', type: 'boolean' },
  { id: '16', name: 'Autorizado Facta', type: 'boolean' },
  { id: '17', name: 'Autorizado Uy3', type: 'boolean' },
  { id: '18', name: 'Autorizado Bmp', type: 'boolean' },
  { id: '19', name: 'Historico Avançado', type: ValoresHistoricos },
  { id: '27', name: 'Agente', type: 'string' },
];

const carteiraFalse: Attribute[] = [
  { id: '1', name: 'Liberado consulta', type: 'boolean' },
  { id: '19', name: 'Historico Avançado', type: ValoresHistoricos },
];


export function getInitialAttributes(selectedWallet: string): Attribute[] {
  return selectedWallet === 'true' ? carteiraTrue : carteiraFalse;
}

export const ListAtributesComponent = (props: Props) => {
  const atributes = props.availableAttributes;
  return (
    <ListGroup style={{ gap: '1rem' }}>
      {atributes.map((attr) => (
        <div key={attr.id} style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
          <div style={{ borderRadius: '0.5rem', background: '#F0F2F5', width: '2rem', height: '2rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <img src={atributesLogo} alt="logo" style={{ width: '1.2rem', height: '1.2rem' }} />
          </div>
          <DraggableItem id={attr.id} name={attr.name} />
        </div>
      ))}
    </ListGroup>
  );
};